<template>
    <div class="inner-wrapper price-calculation" v-if="quotation">
        <div class="page-title quote-title">
            <h1 class="float-left">
                <router-link :to="{name: 'viewQuote', params:{id: $route.params.id}}" class="btn custom-btn back-btn" ><i class="ri-arrow-left-s-line"></i>
                </router-link>
                <button class="btn btn-blue" type="button" @click="view_type=1">Group By Product</button>
                    <button class="btn btn-primary" v-if="vendor_mail_list && vendor_mail_list.length > 0" type="button" @click="view_type=2">Group By Vendor</button>

                    
                    <template v-if="userViewing != null">
                        <ul>
                            
                                <li>{{ userViewing }} is now viewing this page.</li>
                            
                        </ul>
                    </template>
                    
            </h1>
            <div class="title-right float-right">
                <div class="float-left price_calc">
                    <button class="btn btn-primary me-1" data-toggle="modal" data-target="#addVendorModal">Add Vendor
                    </button>
                    <button class="btn btn-dark me-1" data-toggle="modal" data-target="#exportModal">Upload File
                    </button>
                    <a href="javascript:void(0)" data-toggle="modal" data-target="#percentCalculatorModal"
                       class="btn btn-info pull-right">Percent Calculator</a>
                </div>
                <div class="btn-group float-right">
                    <button class="btn  dropdown-toggle" type="button" id="dropdownMenuButtonTop" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        <i class="ri-settings-4-fill align-bottom"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonTop">
                        <div style="height:40px;background:#ffffff;" v-for="(item, index) in cal_versions">
                            <!--<a class="quote_view" href="javascript:void(0)" @click="getCalculation(item.version)">
                                <i class="fas fa-calculator"></i>&nbsp;&nbsp;&nbsp;&nbsp;V-{{ item.version }}.0
                            </a>-->
                            <router-link :to="{name: 'PriceCalculationPage', params: {id: item.id, version: item.version}}" class="quote_view">
                                <i class="fas fa-calculator"></i>&nbsp;&nbsp;&nbsp;&nbsp;V-{{ item.version }}.0
                            </router-link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <div class="alert alert-danger alert-dismissible" role="alert" v-if="errorMessage">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            {{ errorMessage }}
        </div>

        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <ul>
                <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>

        <div class="row dash-bdr" v-if="quotation.price_calc_file != null && quotation.price_calc_file != ''">
            <div class="col-md-12">
                <div class="file-message">
                    <span class="file_label">Previous File :</span>
                    <a style="color: #337ab7"
                       :href="'/quote_price_files/' + quotation.price_calc_file">{{ quotation.price_calc_file }}</a>
                </div>
            </div>
        </div>



        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(saveQuotePrice)" method="post" id="saveQuoteForm"
                  name="saveQuoteForm">
                <div class="row" v-if="form.products">
                    <div class="col-md-12">
                        <div class="">

                            <template v-if="view_type == 1">
                                <template v-for="(product, index) in form.products">
                                    <div class="card  mb-3">
                                        <div class="card-header headnbtn">
                                            <div  class="row">
                                                <div class="col-lg-auto">
                                                    <div class="card-header-left header-left">


                                                        <input type="text" class="form-control search-control" placeholder="Product Name"
                                                            name="product_name" v-model="form.products[index].product_name"/>
                                                    </div>
                                                </div>
                                                <div class="card-header-right header-right col-auto ms-sm-auto">

                                                    <a v-if=" product.vendors.length > 0" href="javascript:void(0)" @click="editVendor(index)"><i  class="ri-edit-box-line align-middle edit-icon-sc edit_vendor_data"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="table-responsive table-card">
                                                <table class="table table-custom table-nowrap table-bordered align-middle mb-0 rescol" v-columns-resizable>
                                                    <thead>
                                                        <tr class="grey-heading">
                                                            <th style="width:350px;">Supplier</th>
                                                            <th style="width:110px;">Pieces</th>
                                                            <th style="width:110px;">Vendor Cost</th>
                                                            <th style="width:110px;">Our % Rate</th>
                                                            <th style="width:110px;">Selling</th>
                                                            <th style="width:160px;">Total Cost</th>
                                                            <th style="width:160px;">Profit</th>
                                                            <th style="width:160px;">Total Amt</th>
                                                            <th style="width:350px;">Notes</th>
                                                            <th style="width:350px;">Admin Note</th>
                                                            <th style="width:40px;"><a v-if=" product.vendors.length > 0" href="javascript:void(0)" @click="addNewTier(index)" class="add-btn2"><i
                                                                class="fa fa-plus-circle"></i></a></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    <tr v-if=" product.vendors.length == 0">
                                                        <td colspan="10">No vendors found!</td>
                                                    </tr>

                                                    <template v-for="(vendor, vendorIndex) in product.vendors.filter((x) => x.all_tiers)">
                                                        <template v-if="vendor.all_tiers && getRowSpan(vendor) > 0">
                                                            <template v-for="(tier, tierIndex) in vendor.all_tiers">
                                                                <template v-if="tier.deleted != 1 && tier.deleted != '1'">
                                                                    <tr :class="'first_tier_' + product.product_id">
                                                                        <td v-if="tierIndex == getFirstRowIndex(vendor)" :class="'frst-td ven_'+ product.product_id + '_' + vendor.vendor_id + '  vendor_' + product.product_id"
                                                                            :rowspan="getRowSpan(vendor)" style="vertical-align: middle;">
                                                                            {{ vendor.contact_name }} ({{ vendor.company_name }})
                                                                            <div style="display: none;">{{ product.description }}</div>
                                                                            <template v-if="isVendorEdit(index, vendorIndex)">
                                                                                <div class="add-input-fild">
                                                                                    <input type="text" placeholder="Enter company name"
                                                                                           v-model="form.products[index].vendors[vendorIndex].company_name"
                                                                                           class="form-control"/>
                                                                                </div>
                                                                                <div class="add-input-fild">
                                                                                    <input type="text" placeholder="Enter contact name"
                                                                                           v-model="form.products[index].vendors[vendorIndex].contact_name"
                                                                                           class="form-control"/>
                                                                                </div>
                                                                                <div class="btn-sec-row">
                                                                                    <a href="javascript:void(0)"
                                                                                       @click="cancelVendorEdit(index, vendorIndex)"
                                                                                       class="close-btn">
                                                                                        <i class="fa fa-times pull-right save-icon cancel_vendor_btn"></i>
                                                                                    </a>
                                                                                    <a href="javascript:void(0)"
                                                                                       @click="saveVendorData(index, vendorIndex)"
                                                                                       class="save-btn">
                                                                                        <i class="fas fa-save pull-right save-icon save_vendor_btn"></i>
                                                                                    </a>
                                                                                </div>
                                                                            </template>

                                                                        </td>
                                                                        <td v-if="tierIndex == getFirstRowIndex(vendor)" style="display: none;" :rowspan="getRowSpan(vendor)"
                                                                            :id="'edit_vendor_'+product.product_id"></td>

                                                                        <td class="text-left">
                                                                            <NumberInput
                                                                                v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].peices" />
                                                                        </td>
                                                                        <td class="tbl-lght-clr">
                                                                            <NumberInput
                                                                                v-on:change="calculate(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].vendor_cost"/>
                                                                        </td>
                                                                        <td class="text-right">
                                                                            <NumberInput
                                                                                v-on:change="calculate(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].rate"/>
                                                                        </td>
                                                                        <td class="tbl-lght-clr">
                                                                            <NumberInput
                                                                                v-on:change="selling_calculate(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].selling"/>
                                                                        </td>
                                                                        <td class="tbl-lght-clr">
                                                                            <NumberInput
                                                                                v-on:change="cost_calculate(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].cost"/>
                                                                        </td>
                                                                        <td class="tbl-lght-clr">
                                                                            <NumberInput
                                                                                v-on:change="profit_calculate(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].profit"/>
                                                                        </td>
                                                                        <td class="tbl-lght-clr">
                                                                            <NumberInput
                                                                                v-on:change="amount_calculate(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].total_amt"/>
                                                                        </td>

                                                                        <td class="notes-td">
                                                                            <textarea rows="1" cols="35" @keyup="resizeTextArea"
                                                                              class="form-control italic-text auto-resize"
                                                                              v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].notes"></textarea>
                                                                        </td>
                                                                         <td class="notes-td">
                                                                            <textarea rows="1" cols="35" @keyup="resizeTextArea"
                                                                              class="form-control italic-text auto-resize"
                                                                              v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].admin_note"></textarea>
                                                                        </td>
                                                                        <td>
                                                                            <ul class="new-note-sec">
                                                                                <li>
                                                                                    <input type="checkbox" @change="priceSelectionChange($event, index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                           v-model="form.products[index].vendors[vendorIndex].all_tiers[tierIndex].price"
                                                                                           value="1">
                                                                                </li>
                                                                                <li><a href="javascript:void(0)"
                                                                                       @click="removeTier(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                       class="remove-btn"><i
                                                                                    class="fa fa-minus-circle"
                                                                                    aria-hidden="true"></i></a></li>
                                                                                <!--<li><a href="javascript:void(0)"
                                                                                    @click="noteLineAdd(index, vendorIndex, tierIndex, 'all_tiers')"
                                                                                    class="add-btn2"><i class="fa fa-plus-circle"
                                                                                                        aria-hidden="true"></i></a>
                                                                                </li>-->
                                                                            </ul>

                                                                        </td>
                                                                        <td style="vertical-align: middle;" :rowspan="getRowSpan(vendor)" v-if="tierIndex == 0"><div v-if="getRowSpan(vendor)" class="remove-btn-price"><i @click="removeVendorAll(vendor.vendor_id,product.product_id)" class="ri-delete-bin-6-line"></i></div></td>
                                                                    </tr>
                                                                </template>

                                                            </template>
                                                        </template>


                                                    </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-if="view_type == 2">
                                <PriceCalculationGroupByVendor :quote_products="quote_products"
                                                               :products="form.products"
                                                               :quote_id="form.quote_id"
                                                               :is_click="form.is_click"
                                                               :price_notes="form.price_notes"
                                                               :check_price="check_price"
                                                               :original_form="form"
                                                               :vendor_mail_list="vendor_mail_list"
                                                               @onApproveQuotations="approveQuotations"
                                                               @onSavePrice="savePrice"
                                                               @onWatchUpdateForm="watchUpdateForm"/>
                            </template>



                        </div>

                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="row g-2">
                                    <div class="col-auto ms-sm-auto">
                                            <template v-if="check_price != null">
                                                <div class="total-price">
                                                    <div class="pull-right" style="padding-right: 40px;">Profit:
                                                        ${{ total_profit.toLocaleString("en-US") }}
                                                    </div>
                                                    <div class="pull-right" style="padding-right: 25px;">Amount: ${{ total_amt.toLocaleString("en-US") }}
                                                    </div>
                                                    <div class="pull-right" style="padding-right: 0px;">Cost: ${{ total_cost.toLocaleString("en-US") }}
                                                    </div>

                                                </div>
                                            </template>
                                    </div><!--end col-->
                                </div><!--end row-->
                            </div><!--end card-body-->
                        </div><!--end card-->

                    </div>
                    <div class="col-md-12">
                        <div class="form-group login_input">
                                <textarea class="form-control" name="price_notes auto-resize" v-model="form.price_notes" @keyup="resizeTextArea"
                                          placeholder="Enter your notes" rows="2"></textarea>
                        </div>
                    </div>
                    <div class="col-md-12">

                        <div class="card panel view-quote-box mb-4" v-if="user">
                            <div class="card-header header-sec">
                                <div class="card-header-left header-left">
                                    <h5 class="card-title flex-grow-1 mb-0" style="line-height: 34px;">Admin Notes {{ adminNoteEditIndex }}</h5>
                                </div>
                                <div class="card-header-right header-right">
                                    <a href="javascript:void(0)" @click="isAdminNoteAdd=true"><span
                                        v-if="(user.user_type == 1 || role == 'Admin') && !isAdminNoteAdd"
                                        class="btn btn-primary btn-sm" id="add-about" style="padding: 0.3rem 1rem;
font-size: 14px;"><i class="ri-add-line align-middle me-1"></i> New</span></a>
                                </div>
                            </div>
                            <div class="card-body">

                                <div class="about-vendorAdd" v-if="isAdminNoteAdd">
                                    <div class="chat-blk " id="about_vendor_add">
                                            <textarea class="form-control mb-2 auto-resize" v-model="adminNote" name="notes" @keyup="resizeTextArea"
                                                      id="notes" placeholder="Add Admin Notes"
                                                      spellcheck="false"></textarea>
                                        <div class="alert alert-danger alert-dismissible" role="alert"
                                             v-if="adminNoteError">
                                            <a href="#" class="close" data-dismiss="alert"
                                               aria-label="close">&times;</a>
                                            {{ adminNoteError }}
                                        </div>
                                        <div class="notes-btns">
                                            <button type="button" class="btn btn-primary" @click="saveAdminNote">Save
                                            </button>
                                            <button type="button" id="close_note" class="btn btn-danger me-1"
                                                    @click="isAdminNoteAdd=false; adminNote=null;">Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="about-vendorAdd">
                                    <div class="about-vendorData"
                                         v-if="admin_notes != null && admin_notes.length > 0">
                                        <div class="task-bg" v-for="(note, index) in admin_notes">

                                            <template v-if="(adminNoteEditIndex == index) && adminNoteEditIndex != null">
                                                <textarea class="form-control mb-2 auto-resize" v-model="note.description" name="notes" @keyup="resizeTextArea"
                                                      id="notes" placeholder="Add Admin Notes"
                                                      spellcheck="false"></textarea>
                                                      <div class="notes-btns">
                                            <button type="button" class="btn btn-primary" @click="editSaveAdminNote(index)">Save
                                            </button>
                                            <button type="button" id="close_note" class="btn btn-danger me-1"
                                                    @click="editSaveCancel(index)">Cancel
                                            </button>
                                        </div>
                                            </template>
                                            <template v-else>
                                            <div class="small-heading">{{ note.description }}</div>
                                            <span class="pull-right lght-clr">{{ note.post_time }}</span>
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="light-clr">Created By {{ note.added_by }}</div>
                                                </div>
                                                <div class="btn-right">
                                                <a href="javascript:void(0)"
                                                    @click="editAdminNote(index,note)"
                                                    class="edit-btn"><i class="fa fa-edit"></i></a>
                                                <a href="javascript:void(0)"
                                                    @click="removeAdminNote(note.id)"
                                                    class="remove-btn"><i
                                                class="fa fa-minus-circle"
                                                aria-hidden="true"></i></a>
                                                </div>
                                            </div>
                                            </template>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="btnrow text-right mb-2">
                    <div class="button-blk pull-right">
                        <template
                            v-if="check_price != null && quotation.status===3 && (user.user_type == 1 || role == 'Admin')">
                            <button type="button" @click="approveQuotations" class="btn btn-blue action_btn me-1"
                                    id="approve_btn"><span class="fas fa-thumbs-up"></span> Approve Price
                            </button>
                        </template>
                        <button type="button" class="btn btn-info me-1 w-md save_price " @click="savePrice(1)">Save
                        </button>
                        <button type="button" class="btn btn-blue " @click="savePrice(2)">Save & Complete
                        </button>

                    </div>
                </div>
            </form>
        </ValidationObserver>




        <footer class="footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-6">
                                2022 © Superb.
                            </div>
                            <div class="col-sm-6">
                                <div class="text-right d-none d-sm-block">
                                    All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

        <PercentCalculatorModal></PercentCalculatorModal>
        <!-- Vendor Modal -->
        <div class="modal fade" id="addVendorModal" role="dialog">
            <div class="modal-dialog  modal-md modal-dialog-scrollable">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header bg-soft-info">
                        <h5 class="modal-title">Add Vendor</h5>
                        <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                    </div>
                    <div class="modal-body">
                        <ValidationObserver v-slot="{ handleSubmit }">
                            <form @submit.prevent="handleSubmit(addVendor)" method="post" id="addVendorForm">
                                <div id="vendor_error_alert" class="alert alert-danger" style="display: none;">
                                    <strong>Please fill out * fields</strong>
                                </div>

                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <v-select required label="text" placeholder="Select vendor" :filterable="false"
                                                  :multiple="true"
                                                  v-model="addVendorForm.vendor_list"
                                                  :options="vendors"
                                                  :reduce="vendor => vendor.id"
                                                  @search="onVendorSearch"
                                                  @selected="onVendorSelect"
                                                  @deselected="onVendorDeSelect">
                                            <template slot="no-options">
                                                type to search vendors..
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center" v-html="option.html">
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center" v-html="option.text">
                                                </div>
                                            </template>
                                        </v-select>
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>


                                <div class="button-blk pull-left">
                                    <button class="btn btn-danger me-1" data-dismiss="modal"> Cancel</button>
                                    <button type="submit" class="btn btn-primary w-sm" id="add_vendor_btn">Add</button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>

            </div>
        </div>
        <!-- /End Vendor Modal -->

        <div class="modal fade" id="exportModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog  modal-md modal-dialog-scrollable" role="document">
                <div class="modal-content">

                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form @submit.prevent="handleSubmit(importPriceFile)" method="post" class="form form-horizontal"
                              name="frmPriceImport" id="frmPriceImport" enctype="multipart/form-data">

                             <div class="modal-header bg-soft-info">
                                <h5 class="modal-title" id="exampleModalLabel">Upload File</h5>
                                <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                            </div>
                            <div class="modal-body">
                                <div id="file_error_alert" class="alert alert-danger" style="display: none;">
                                    <strong>Please fill out * fields</strong>
                                </div>
                                <div class="form-body">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <div class="file-upload">
                                            <div class="file-select">
                                                <!--<div class="file-select-button" id="fileName">Choose File</div>
                                                <div class="file-select-name" id="noFile">No file chosen...</div>-->
                                                <input type="file" name="chooseFile" id="chooseFile"
                                                       @change="handlePriceImportFileUpload( $event )" accept=".csv" class="form-control">
                                                <input type="hidden" v-model="importPriceForm.chooseFile">
                                                <span>{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="mt-3">
                                    <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Close</button>
                                    <button type="submit" class="btn btn-primary w-sm" id="upload_btn">Upload</button>
                                </div>
                            </div>

                        </form>
                    </ValidationObserver>

                </div>
            </div>
        </div>

        <div class="modal fade" id="addNotesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog  modal-md modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-soft-info">
                        <h5 class="modal-title">Add Note</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="noteLineSave(false)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="" method="post" class="form form-horizontal" name="frmPriceNotes"
                              id="frmPriceNotes" enctype="multipart/form-data">
                            <div class="alert alert-danger" style="display: none;">
                                <strong>Please fill out * fields</strong>
                            </div>
                            <div class="form-body">
                                <div class="form-group">
                                    <label for="noteText">Note:</label>
                                    <input type="text" class="form-control" id="noteText" v-model="addNoteForm.notes">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger me-1" @click="noteLineSave(false)" data-dismiss="modal">
                            Close
                        </button>
                        <button type="button" class="btn btn-primary w-sm" @click="noteLineSave(true)">Add</button>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import PercentCalculatorModal from "../../components/PercentCalculatorModal";
import PriceCalculationGroupByVendor from "../../components/PriceCalculationGroupByVendor";
import NumberInput from "../../components/NumberInput";
import AutoTextarea from "../../components/AutoTextarea";

export default {
    name: "PriceCalculation",
    components: {
        PercentCalculatorModal,
        ValidationProvider,
        ValidationObserver,
        PriceCalculationGroupByVendor,
        NumberInput,
        AutoTextarea
    },
    created() {
        this.addVendorForm.quote_id = this.$route.params.id;
        this.importPriceForm.quote_upload_id = this.$route.params.id;
        this.id = this.$route.params.id;
        this.getCalculation();
    },
    mounted() {
       // alert(`calculation.${this.$route.params.id}`);
        this.$echo.private(`calculation.${this.$route.params.id}`)
                .listen('.CalculationPage', (e) => {
                    
                    const parsedView = JSON.parse(e.message);
                    console.log(parsedView)
                    
                    this.userViewing = parsedView.name;
                    // if (this.userViewing.includes(parsedView.name)) {
                    //     //console.log(`${value} already exists.`);
                    // } else {
                    //     this.userViewing = parsedView.name;
                    // }


                    
                    console.log("this.userViewing ",this.userViewing)
                   
                });
    },
    data() {
        return {
            userViewing:null,
            adminNoteEditIndex:null,
            check_price: null,
            quote_products: [],
            admin_notes: [],
            vendor_mail_list: [],
            id: null,
            quotation: null,
            cal_versions: [],

            count_product: null,
            notify: null,
            DesktopNotification: null,
            total_amt: null,
            total_cost: null,
            total_profit: null,
            products: null,
            versions: null,

            user: null,
            role: null,

            addVendorForm: {
                vendor_list: [],
                quote_id: null
            },
            vendors: [],

            importPriceForm: {
                chooseFile: null,
                quote_upload_id: this.$route.params.id
            },

            editableVendorByProduct: [],

            view_type: 1, // 1 product -> vendor, 2 => vendor -> product
            form: {
                quote_id: this.$route.params.id,
                price_notes: null,
                is_click: null,
                products: [
                    {
                        product_id: null,
                        description: null,
                        product_name: null,
                        quantity_unit: null,
                        vendors: [
                            {
                                vendor_id: null,
                                contact_id: null,
                                company_name: null,
                                contact_name: null,
                                quote_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        admin_note:null,
                                        price: 0,
                                        deleted: null,
                                    }
                                ],
                                primary_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        admin_note:null,
                                        price: 0,
                                        deleted: null,
                                    }
                                ],
                                rest_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        admin_note:null,
                                        price: 0,
                                        deleted: null,
                                    }
                                ],
                                all_tiers: [
                                    {
                                        tier_value: null,
                                        peices: null,
                                        vendor_cost: null,
                                        rate: null,
                                        selling: null,
                                        cost: null,
                                        profit: null,
                                        total_amt: null,
                                        notes: null,
                                        admin_note:null,
                                        price: 0,
                                        deleted: null,
                                    }
                                ],
                            }
                        ]
                    }
                ],
            },

            vendorDataSaveError: null,

            addNoteForm: {
                index: null,
                vendorIndex: null,
                tierIndex: null,
                tierType: null,
                notes: null
            },

            isAdminNoteAdd: false,
            adminNote: null,
            adminNoteError: null,
            restoreFromState: true
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setPriceCalculation'
        ]),
        
removeVendorAll(vendor,productId){
            console.log("vendor",vendor);
            console.log("productId",productId);

            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete vendor?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios.post(window.route('removeVendorAllPrice'), {
                            vendor_id: vendor,
                            quote_id: this.id,
                            product_id: productId
                        }, {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(data.data);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                    self.getCalculation();
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });


        },
        removeAdminNote(id){
            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete item?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        
                        
                        this.setLoading(true);
                        this.setCommonErrors([]);
                        this.setErrorMessage(null);
                        let payload = {
                            id: id,
                           
                        };

                        return axios.post(window.route('delete_admin_notes'), payload, {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    this.setSuccessMessage(data.data);
                                    // this.admin_notes.push(data.about_vendor);
                                    // this.isAdminNoteAdd = false;
                                    // this.adminNote = null;
                                    this.adminNoteEditIndex = null;
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                        this.getCalculation();
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                            

                    }

                }
            });

        },
        editAdminNote(index,note){
            this.adminNoteEditIndex = index;
        },
        editSaveAdminNote(index){
            
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            this.adminNoteError = null;

            if (this.admin_notes[index].description === null) {
                this.adminNoteError = "Note cannot be empty";
                this.setLoading(false);
                return false;
            }

            let payload = {
                quote_id: this.id,
                notes: this.admin_notes[index].description,
                note_id:this.admin_notes[index].id,
            };

            return axios.post(window.route('editAdminNotes'), payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        // this.admin_notes.push(data.about_vendor);
                        // this.isAdminNoteAdd = false;
                        // this.adminNote = null;
                        this.adminNoteEditIndex = null;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        editSaveCancel(index){
            this.adminNoteEditIndex = null;
        },
        getRowSpan(vendor){
            /*let total = vendor.primary_tiers.filter((t) => t.deleted != 1 && t.deleted != '1').length +
                vendor.rest_tiers.filter((t) => t.deleted != 1 && t.deleted != '1').length*/
            if(typeof vendor.all_tiers == 'undefined') {
                return 0;
            }
            let total = vendor.all_tiers.filter((t) => t.deleted != 1 && t.deleted != '1').length;
            // console.log(total, vendor.company_name, vendor)
            return total;
        },
        getFirstRowIndex(vendor){
            let firstRowIndex = -1;

            if(typeof vendor.all_tiers == 'undefined') {
                return 0;
            }

            vendor.all_tiers.forEach((t, index) => {
                if( t.deleted != 1 && t.deleted != '1' && firstRowIndex == -1) {
                    firstRowIndex = index;
                }
            });

            return firstRowIndex;
        },
        resizeTextArea(event){
            event.target.style.height = event.target.scrollHeight +"px";
        },
        watchUpdateForm(form){
            this.form = _.cloneDeep(form);
        },
        approveQuotations() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.post(window.route('ApproveQuotations'), {id: this.id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$router.push({name: 'viewQuote', params:{id: this.id}});
                        // this.getCalculation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        savePrice(is_click) {
            this.form.is_click = is_click;
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.post(window.route('saveQuotePrice'), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getCalculation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        removeVendor(vendor) {
            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete vendor?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios.post(window.route('removeVendor'), {
                            con_id: vendor.contact_id,
                            quote_id: this.id,
                            p_id: vendor.vendor_id
                        }, {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(data.data);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                    self.getCalculation();
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });
        },
        saveAdminNote() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            this.adminNoteError = null;

            if (this.adminNote === null || this.adminNote === '') {
                this.adminNoteError = "Note cannot be empty";
                this.setLoading(false);
                return false;
            }

            let payload = {
                quote_id: this.id,
                notes: this.adminNote
            };

            return axios.post(window.route('adminNotes'), payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        this.admin_notes.push(data.about_vendor);
                        this.isAdminNoteAdd = false;
                        this.adminNote = null;

                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        saveVendorData(index, vIndex) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            this.vendorDataSaveError = null;

            let payload = {
                vendor_id: this.form.products[index].vendors[vIndex].vendor_id,
                contact_name: this.form.products[index].vendors[vIndex].contact_name,
                company_name: this.form.products[index].vendors[vIndex].company_name
            };

            if (payload.contact_name === '') {
                this.vendorDataSaveError = "Please enter contact name";
            }
            if (payload.company_name === '') {
                this.vendorDataSaveError = "Please enter company name";
            }

            if (this.vendorDataSaveError != null) {
                self.setErrorMessage(this.vendorDataSaveError);
                this.setLoading(false);
                return false;
            }

            return axios.post(window.route('update_vendor_data'), payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage('Vendor information updated successfully.');
                        this.form.products.forEach((prod, prodIndex) => {
                            prod.vendors.forEach((vendor, vendorIndex) => {
                                if (vendor.vendor_id === payload.vendor_id) {
                                    this.form.products[prodIndex].vendors[vendorIndex].contact_name = payload.contact_name;
                                    this.form.products[prodIndex].vendors[vendorIndex].company_name = payload.company_name;
                                }
                            });
                        });
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.cancelVendorEdit(index, vIndex);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });

        },
        cancelVendorEdit(index, vIndex) {
            this.editableVendorByProduct.splice(this.editableVendorByProduct.findIndex((x) => x.prodIndex === index && x.vIndex === vIndex), 1);
        },
        editVendor(index) {
            this.form.products[index].vendors.forEach((v, vIndex) => {
                this.editableVendorByProduct.push({prodIndex: index, vIndex: vIndex});
            });
        },
        isVendorEdit(index, vIndex) {
            return this.editableVendorByProduct.length > 0 && this.editableVendorByProduct.findIndex((x) => x.prodIndex === index && x.vIndex === vIndex) != -1;
        },
        saveQuotePrice() {
            this.savePrice();
        },
        importPriceFile() {
            // alert('Form has been submitted!');
            let formData = new FormData();
            formData.append('chooseFile', this.importPriceForm.chooseFile);
            formData.append('quote_upload_id', this.importPriceForm.quote_upload_id);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('importPriceFile'), formData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        $("#exportModal").modal("hide");
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        handlePriceImportFileUpload(event) {
            this.importPriceForm.chooseFile = event.target.files[0];
        },
        addVendor() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('AddVendorPrice'), this.addVendorForm, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        $("#addVendorModal").modal("hide");
                        this.restoreFromState = true;
                        this.setPriceCalculation(this.form);
                        this.getCalculation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        addNewTier(index) {
            let newTier = {
                id: null,
                tier_value: "0",
                peices: "0",
                vendor_cost: '$0',
                rate: '0%',
                selling: '$0',
                cost: '$0',
                profit: '$0',
                total_amt: '$0',
                notes: null,
                admin_note:null,
                price: 0,
                deleted: '0',
            };
            this.form.products[index].vendors.forEach((vendor, vendorIndex) => {
                /*let primary_tiers = this.form.products[index].vendors[vendorIndex].primary_tiers.filter((t) => t.deleted != 1 && t.deleted != '1');
                let rest_tiers = this.form.products[index].vendors[vendorIndex].rest_tiers.filter((t) => t.deleted != 1 && t.deleted != '1');

                if(primary_tiers.length > 0 || rest_tiers.length > 0) {
                    this.form.products[index].vendors[vendorIndex].quote_tiers.push(_.cloneDeep(newTier));

                    if(primary_tiers.length > 0) {
                        this.form.products[index].vendors[vendorIndex].rest_tiers.push(_.cloneDeep(newTier));
                    } else {
                        this.form.products[index].vendors[vendorIndex].primary_tiers.push(_.cloneDeep(newTier));
                    }
                }*/
                if(this.getRowSpan(this.form.products[index].vendors[vendorIndex]) > 0) {
                    this.form.products[index].vendors[vendorIndex].all_tiers.push(_.cloneDeep(newTier));
                }
            });
            this.setPriceCalculation(this.form);
        },
        getCalculation(version = null) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('PriceCalculationPage', {
                id: this.$route.params.id,
                version: version ? version : this.$route.params.version,
                //version: version
            }), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.quotation = data.data.quotations;
                        this.quote_products = data.data.quote_products;

                        this.quote_products.forEach((product, index) => {
                            if (data.data.check_price && product.vendors) {
                                product.vendors.forEach((vendor) => {
                                    if(vendor.quote_tiers.length == 0) {
                                        /*vendor.quote_tiers.push({
                                            tier_value: "0",
                                            peices: "0",
                                            vendor_cost: '$0',
                                            rate: '0%',
                                            selling: '$0',
                                            cost: '$0',
                                            profit: '$0',
                                            total_amt: '$0',
                                            notes: null,
                                            price: 0,
                                            deleted: null,
                                        });*/
                                    }
                                    if(vendor.primary_tiers.length == 0) {
                                        /*vendor.primary_tiers.push({
                                            tier_value: "0",
                                            peices: "0",
                                            vendor_cost: '$0',
                                            rate: '0%',
                                            selling: '$0',
                                            cost: '$0',
                                            profit: '$0',
                                            total_amt: '$0',
                                            notes: null,
                                            price: 0,
                                            deleted: null,
                                        });*/
                                    }
                                    /*if(typeof vendor.all_tiers == 'undefined' || vendor.all_tiers.length == 0) {
                                        vendor.all_tiers.push({
                                            tier_value: "0",
                                            peices: "0",
                                            vendor_cost: '$0',
                                            rate: '0%',
                                            selling: '$0',
                                            cost: '$0',
                                            profit: '$0',
                                            total_amt: '$0',
                                            notes: null,
                                            price: 0,
                                            deleted: null,
                                        });
                                    }*/
                                    vendor.quote_tiers.forEach((tier) => {
                                        if(tier.peices == 'NA') {
                                            tier.peices = 0;
                                        }
                                        tier.vendor_cost = tier.vendor_cost ? "$" + tier.vendor_cost.replace("$", "") : "$0.00";
                                        tier.rate = tier.rate ? tier.rate.replace("%", "")  + '%' : "0%";
                                        tier.selling = tier.selling ? "$" + tier.selling.replace("$", "") : "$0.00";
                                        tier.cost = tier.cost ? "$" + tier.cost.replace("$", "") : "$0.00";
                                        tier.profit =  tier.profit ? "$" + tier.profit.replace("$", "") : "$0.00";
                                        tier.total_amt = tier.total_amt ? "$" + tier.total_amt.replace("$", "") : "$0.00";
                                    });
                                    vendor.primary_tiers.forEach((tier) => {
                                        if(tier.peices == 'NA') {
                                            tier.peices = 0;
                                        }
                                        tier.vendor_cost = tier.vendor_cost ? "$" + tier.vendor_cost.replace("$", "") : "$0.00";
                                        tier.rate = tier.rate ? tier.rate.replace("%", "")  + '%' : "0%";
                                        tier.selling = tier.selling ? "$" + tier.selling.replace("$", "") : "$0.00";
                                        tier.cost = tier.cost ? "$" + tier.cost.replace("$", "") : "$0.00";
                                        tier.profit =  tier.profit ? "$" + tier.profit.replace("$", "") : "$0.00";
                                        tier.total_amt = tier.total_amt ? "$" + tier.total_amt.replace("$", "") : "$0.00";
                                    });
                                    vendor.rest_tiers.forEach((tier) => {
                                        if(tier.peices == 'NA') {
                                            tier.peices = 0;
                                        }
                                        tier.vendor_cost = tier.vendor_cost ? "$" + tier.vendor_cost.replace("$", "") : "$0.00";
                                        tier.rate = tier.rate ? tier.rate.replace("%", "")  + '%' : "0%";
                                        tier.selling = tier.selling ? "$" + tier.selling.replace("$", "") : "$0.00";
                                        tier.cost = tier.cost ? "$" + tier.cost.replace("$", "") : "$0.00";
                                        tier.profit =  tier.profit ? "$" + tier.profit.replace("$", "") : "$0.00";
                                        tier.total_amt = tier.total_amt ? "$" + tier.total_amt.replace("$", "") : "$0.00";
                                    });

                                    vendor.all_tiers.forEach((tier) => {
                                        if(tier.peices == 'NA') {
                                            tier.peices = 0;
                                        }
                                        tier.vendor_cost = tier.vendor_cost ? "$" + tier.vendor_cost.replace("$", "") : "$0.00";
                                        tier.rate = tier.rate ? tier.rate.replace("%", "")  + '%' : "0%";
                                        tier.selling = tier.selling ? "$" + tier.selling.replace("$", "") : "$0.00";
                                        tier.cost = tier.cost ? "$" + tier.cost.replace("$", "") : "$0.00";
                                        tier.profit =  tier.profit ? "$" + tier.profit.replace("$", "") : "$0.00";
                                        tier.total_amt = tier.total_amt ? "$" + tier.total_amt.replace("$", "") : "$0.00";
                                    });
                                });
                            } else {
                                if(product.quote_tiers.length == 0) {
                                    product.quote_tiers.push({
                                        tier_value: "0",
                                        peices: "0",
                                        vendor_cost: '$0',
                                        rate: '0%',
                                        selling: '$0',
                                        cost: '$0',
                                        profit: '$0',
                                        total_amt: '$0',
                                        notes: null,
                                        admin_note:null,
                                        price: 0,
                                        deleted: null,
                                    });
                                }
                                product.quote_tiers.forEach((tier, tIndex) => {
                                    if(tier.peices == 'NA') {
                                        tier.peices = 0;
                                    }
                                    tier.vendor_cost = tier.vendor_cost ? "$" + tier.vendor_cost.replace("$", "") : "$0.00";
                                    tier.rate = tier.rate ? tier.rate.replace("%", "")  + '%' : "0%";
                                    tier.selling = tier.selling ? "$" + tier.selling.replace("$", "") : "$0.00";
                                    tier.cost = tier.cost ? "$" + tier.cost.replace("$", "") : "$0.00";
                                    tier.profit =  tier.profit ? "$" + tier.profit.replace("$", "") : "$0.00";
                                    tier.total_amt = tier.total_amt ? "$" + tier.total_amt.replace("$", "") : "$0.00";
                                });

                                /*if(typeof product.all_tiers == 'undefined' || product.all_tiers.length == 0) {
                                    product.all_tiers.push({
                                        tier_value: "0",
                                        peices: "0",
                                        vendor_cost: '$0',
                                        rate: '0%',
                                        selling: '$0',
                                        cost: '$0',
                                        profit: '$0',
                                        total_amt: '$0',
                                        notes: null,
                                        price: 0,
                                        deleted: null,
                                    });
                                }*/
                            }
                        });

                        this.admin_notes = data.data.admin_notes;
                        this.vendor_mail_list = data.data.vendor_mail_list;
                        this.id = data.data.id;
                        this.cal_versions = data.data.cal_version;

                        this.count_product = data.data.count_product;
                        this.notify = data.data.notify;
                        this.DesktopNotification = data.data.DesktopNotification;
                        /*
                        this.total_amt = data.data.total_amt;
                        this.total_cost = data.data.total_cost;
                        this.total_profit = data.data.total_profit;
                        */

                        this.total_amt = data.data.all_total_amt;
                        this.total_cost = data.data.all_total_cost;
                        this.total_profit = data.data.all_total_profit;

                        this.products = data.data.products;
                        this.versions = data.data.versions;
                        this.check_price = data.data.check_price;

                        this.user = data.data.user;
                        this.role = data.data.role;

                        // create the form
                        this.form.quote_id = this.$route.params.id;
                        this.form.price_notes = this.quotation.price_notes;
                        this.form.products = [];
                        if (this.check_price) {
                            this.form.products = this.quote_products;
                        } else {
                            this.quote_products.forEach((product, index) => {
                                let vendors = [];
                                this.vendor_mail_list.forEach((vendor, vendorIndex) => {
                                    let newVendor = {
                                        vendor_id: vendor.vendor_id,
                                        contact_id: vendor.contact_id,
                                        company_name: vendor.company_name,
                                        contact_name: vendor.contact_name,
                                        quote_tiers: product.quote_tiers,
                                        primary_tiers: [],//product.primary_tiers,
                                        rest_tiers: [], // product.rest_tiers,
                                        all_tiers: [], // product.all_tiers,
                                    }

                                    newVendor.primary_tiers = [];
                                    product.quote_tiers.forEach((tier, tIndex) => {
                                        let newTier = {
                                            tier_value: tier.tier_value,
                                            peices: tier.tier_value,
                                            vendor_cost: '$0',
                                            rate: '0%',
                                            selling: '$0',
                                            cost: '$0',
                                            profit: '$0',
                                            total_amt: '$0',
                                            notes: null,
                                            price: 0,
                                            deleted: null,
                                        };
                                        if (tIndex === 0) {
                                            newVendor.primary_tiers.push(newTier);
                                        } else {
                                            newVendor.rest_tiers.push(newTier);
                                        }
                                        product.quote_tiers[tIndex] = newTier;
                                    });

                                    newVendor.all_tiers = [];
                                    product.all_tiers.forEach((tier, tIndex) => {
                                        let newTier = {
                                            tier_value: tier.tier_value,
                                            peices: tier.tier_value,
                                            vendor_cost: '$0',
                                            rate: '0%',
                                            selling: '$0',
                                            cost: '$0',
                                            profit: '$0',
                                            total_amt: '$0',
                                            notes: null,
                                            admin_note:null,
                                            price: 0,
                                            deleted: null,
                                        };
                                        newVendor.all_tiers.push(newTier);
                                        product.quote_tiers[tIndex] = newTier;
                                    });


                                    vendors.push(newVendor);
                                });

                                let newProduct = {
                                    product_id: product.product_id,
                                    description: product.description,
                                    product_name: product.product_name,
                                    quantity_unit: product.quantity_unit,
                                    deleted: product.deleted ? product.deleted : null,
                                    vendors: vendors
                                };
                                this.form.products.push(newProduct)
                            });
                        }


                        this.setPriceCalculation(this.form);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        onVendorSelect(event) {
            console.log(event)
        },
        onVendorDeSelect(event) {
            console.log(event)
        },
        onVendorSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchVendor(loading, search, this);
            }
        },
        searchVendor: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchVendors'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {

                    } else {
                        vm.vendors = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        priceSelectionChange(event, index, vendorIndex, tierIndex, tierType) {
            // form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].price

            if(event.target.checked) {
                //console.log(event)
                this.form.products[index].vendors.forEach((vendor, vIndex) => {
                    if(vendorIndex != vIndex) {
                        vendor[tierType][tierIndex].price = false;
                    }
                });
            }
        },
        removeTier(index, vendorIndex, tierIndex, tierType) {
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete item?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        if(this.form.products[index].vendors[vendorIndex][tierType][tierIndex].id) {
                            this.form.products[index].vendors[vendorIndex][tierType][tierIndex].deleted = '1';
                            // this.form.products[index].vendors[vendorIndex]['quote_tiers'][tierIndex].deleted = '1';
                        } else {
                            this.form.products[index].vendors[vendorIndex][tierType].splice(tierIndex, 1);
                        }

                        /*if(tierType == 'primary_tiers' && this.form.products[index].vendors[vendorIndex].rest_tiers) {
                            let rest_tiers = this.form.products[index].vendors[vendorIndex].rest_tiers.filter((t) => t.deleted != 1 && t.deleted != '1');
                            if(rest_tiers.length) {
                                setTimeout(() => {
                                    this.form.products[index].vendors[vendorIndex].primary_tiers.push(_.cloneDeep(rest_tiers[0]));
                                    this.form.products[index].vendors[vendorIndex].rest_tiers.splice(0, 1);
                                }, 50);

                            }
                        }*/
                    }

                }
            });
        },
        noteLineRemove(index, vendorIndex, tierIndex, tierType) {
            let notes = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].notes;
            if(notes == null) {
                notes = '';
            }
            let ks = notes.split("\n");
            let checkLength = ks.length - 2;
            let dataAppend = '';
            $.each(ks, function (k) {
                if (k < checkLength) {
                    dataAppend += ks[k] + "\n";
                }
            });
            this.form.products[index].vendors[vendorIndex][tierType][tierIndex].notes = dataAppend;
        },
        noteLineAdd(index, vendorIndex, tierIndex, tierType) {
            this.addNoteForm = {
                index: index,
                vendorIndex: vendorIndex,
                tierIndex: tierIndex,
                tierType: tierType,
                notes: null
            };
            $('#addNotesModal').modal('show');
        },
        noteLineSave(isSave) {
            if (isSave) {
                let notes = this.form.products[this.addNoteForm.index].vendors[this.addNoteForm.vendorIndex][this.addNoteForm.tierType][this.addNoteForm.tierIndex].notes;
                if(notes == null) {
                    notes = '';
                }
                let ks = notes.split("\n");
                let dataAppend = '';

                $.each(ks, function (k) {
                    dataAppend += ks[k] + "\n";
                });

                dataAppend += this.addNoteForm.notes + "\n";

                this.form.products[this.addNoteForm.index].vendors[this.addNoteForm.vendorIndex][this.addNoteForm.tierType][this.addNoteForm.tierIndex].notes = dataAppend;
            }
            this.addNoteForm = {
                index: null,
                vendorIndex: null,
                tierIndex: null,
                tierType: null,
                notes: null
            };
            $('#addNotesModal').modal('hide');
        },
        calculate(index, vendorIndex, tierIndex, tierType) {
            let peices = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].peices;

            if(isNaN(peices)) {
                peices = peices.replace(",", "");
                peices = peices.replace("ft", "");
                // peices = peices.replace(/[_\W]+/g, "");
            }


            let vendor_cost = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost;
            if(isNaN(vendor_cost))
                vendor_cost = vendor_cost.replace("$", "");
            let rate = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].rate;
            if(isNaN(rate))
                rate = rate.replace("%", "");
            if (vendor_cost > 0) {
                let rate_calc = ((vendor_cost * rate) / 100).toFixed(3);
                let selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                } else {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(3);
                }
                let cost = (vendor_cost * peices).toFixed(3);
                let profit = (rate_calc * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                selling = '$' + selling;
                profit = '$' + profit;
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                vendor_cost = '$' + vendor_cost;
                rate = rate + '%';
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling = selling;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost = cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].profit = profit;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt = total_amt;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].rate = rate;
            }
        },
        selling_calculate(index, vendorIndex, tierIndex, tierType) {
            let peices = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let selling = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling;
            selling = selling.replace("$", "");
            let vendor_cost = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost;
            vendor_cost = vendor_cost.replace("$", "");
            let difference = parseFloat(selling) - parseFloat(vendor_cost);
            if (difference > 0 && vendor_cost > 0) {
                let rate_calc = ((difference * 100) / vendor_cost).toFixed(2);
                rate_calc = rate_calc + '%';
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].rate = rate_calc;
                let cost = (vendor_cost * peices).toFixed(2);
                let profit = (difference * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                profit = '$' + profit;
                selling = '$' + selling;

                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost = cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].profit = profit;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt = total_amt;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling = selling;
            }
        },
        cost_calculate(index, vendorIndex, tierIndex, tierType) {
            let peices = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let cost = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost;
            cost = cost.replace("$", "");
            let vendor_cost = (cost / peices).toFixed(2);
            let rate = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].rate;
            rate = rate.replace("%", "");
            if (vendor_cost > 0) {
                let rate_calc = ((vendor_cost * rate) / 100).toFixed(3);
                let selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(2);
                } else {
                    selling = (parseFloat(vendor_cost) + parseFloat(rate_calc)).toFixed(3);
                }
                let profit = (rate_calc * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                vendor_cost = '$' + vendor_cost;
                selling = '$' + selling;
                cost = '$' + cost;
                profit = '$' + profit;
                total_amt = '$' + total_amt;

                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling = selling;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost = cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].profit = profit;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt = total_amt;
            }

        },
        profit_calculate(index, vendorIndex, tierIndex, tierType) {
            let peices = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let profit = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].profit;
            profit = profit.replace("$", "");
            let vendor_cost = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost;
            vendor_cost = vendor_cost.replace("$", "");
            let profit_differnce = (profit / peices);
            if (vendor_cost > 0 && profit_differnce > 0) {
                let selling = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling;
                selling = selling.replace("$", "");
                selling = (parseFloat(vendor_cost) + parseFloat(profit_differnce)).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (parseFloat(vendor_cost) + parseFloat(profit_differnce)).toFixed(2);
                } else {
                    selling = (parseFloat(vendor_cost) + parseFloat(profit_differnce)).toFixed(3);
                }
                let difference = (parseFloat(selling) - parseFloat(vendor_cost)).toFixed(2);
                let rate_calc = ((difference * 100) / vendor_cost).toFixed(2);
                let cost = (vendor_cost * peices).toFixed(2);
                let total_amt = (parseFloat(cost) + parseFloat(profit)).toFixed(2);
                rate_calc = rate_calc + '%';
                selling = '$' + selling;
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                profit = '$' + profit;

                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].rate = rate_calc;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling = selling;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost = cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].profit = profit;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt = total_amt;
            }
        },
        amount_calculate(index, vendorIndex, tierIndex, tierType) {
            let peices = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].peices;
            peices = peices.replace(",", "");
            peices = peices.replace("ft", "");
            // peices = peices.replace(/[_\W]+/g, "");
            let total_amt = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt;
            total_amt = total_amt.replace("$", "");
            peices = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].peices;
            peices = peices.replace("$", "");
            let profit = this.form.products[index].vendors[vendorIndex][tierType][tierIndex].profit;
            profit = profit.replace("$", "");
            if (profit > 0) {
                let cost = (parseFloat(total_amt) - parseFloat(profit)).toFixed(2);
                let selling = (total_amt / peices).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (total_amt / peices).toFixed(2);
                } else {
                    selling = (total_amt / peices).toFixed(3);
                }
                let vendor_cost = (cost / peices).toFixed(2);
                let difference = (parseFloat(selling) - parseFloat(vendor_cost)).toFixed(2);
                let rate_calc = ((difference * 100) / vendor_cost).toFixed(2);
                selling = '$' + selling;
                cost = '$' + cost;
                vendor_cost = '$' + vendor_cost;
                total_amt = '$' + total_amt;
                rate_calc = rate_calc + '%';

                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling = selling;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost = cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].rate = rate_calc;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt = total_amt;
            } else if (this.form.products[index].vendors[vendorIndex][tierType][tierIndex].rate > 0) {
                let selling = (total_amt / peices).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (total_amt / peices).toFixed(2);
                } else {
                    selling = (total_amt / peices).toFixed(3);
                }
                profit = (total_amt / selling).toFixed(2);
                let cost = (parseFloat(total_amt) - parseFloat(profit)).toFixed(2);
                let vendor_cost = (cost / peices).toFixed(2);
                selling = '$' + selling;
                profit = '$' + profit;
                vendor_cost = '$' + vendor_cost;
                total_amt = '$' + total_amt;
                cost = '$' + cost;

                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling = selling;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].profit = profit;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost = vendor_cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost = cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt = total_amt;
            } else {
                let cost = total_amt;
                let selling = (cost / peices).toFixed(2);
                let data = this.isEven(selling.toString().split(".")[1]);
                if (data) {
                    selling = (cost / peices).toFixed(2);
                } else {
                    selling = (cost / peices).toFixed(3);
                }
                let vendor_cost = selling;
                selling = '$' + selling;
                cost = '$' + cost;
                total_amt = '$' + total_amt;
                vendor_cost = '$' + vendor_cost;

                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].selling = selling;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].cost = cost;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].total_amt = total_amt;
                this.form.products[index].vendors[vendorIndex][tierType][tierIndex].vendor_cost = vendor_cost;
            }
            return false;
        }

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
            'priceCalculation'
        ])
    },
    watch: {
        'form.products': {
            handler: function (after, before) {
                //console.log(after)
                //form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].peices
                //form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].vendor_cost
                //form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].rate
                //form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].selling
                //form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].cost
                //form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].profit
                //form.products[index].vendors[vendorIndex].rest_tiers[tierIndex].total_amt
                /*if(after) {
                    after.forEach((prod) => {
                        if(prod.vendors) {
                            prod.vendors.forEach((vendor) => {
                                if(vendor.primary_tiers) {
                                    vendor.primary_tiers.forEach((tier) => {
                                        tier.peices = tier.peices;
                                        tier.vendor_cost = tier.vendor_cost;
                                        tier.rate = tier.rate;
                                        tier.selling = tier.selling;
                                        tier.cost = tier.cost;
                                        tier.profit = tier.profit;
                                        tier.total_amt = tier.total_amt;
                                    })
                                }
                                if(vendor.rest_tiers) {
                                    vendor.rest_tiers.forEach((tier) => {
                                        tier.peices = tier.peices;
                                        tier.vendor_cost = tier.vendor_cost;
                                        tier.rate = tier.rate;
                                        tier.selling = tier.selling;
                                        tier.cost = tier.cost;
                                        tier.profit = tier.profit;
                                        tier.total_amt = tier.total_amt;
                                    })
                                }
                            });
                        }
                    });
                }*/
            },
            deep: true,
        },
        'form': {
            handler: function (after, before) {
                // Wait until the template has updated
                this.$nextTick(() => {
                    [...document.querySelectorAll('textarea')].forEach(textarea => {
                        this.resizeTextArea({ target: textarea });
                    });
                });
            },
            deep: true,
        },
    }

}
</script>

<style scoped>

</style>
